import { Component, Input, OnInit } from '@angular/core';
import { Wiki } from '@local/client-contracts';
import { Constants } from '@local/common';
import { Icon } from '@local/ui-infra';
import { EventsService } from '@shared/services';
import { CollectionsService } from 'src/app/bar/services/collections.service';
import { CollectionsUtilService } from 'src/app/bar/services/collections-util.service';
import { HubService } from 'src/app/bar/services/hub.service';
import { wikiContent } from '../../helpers/wiki.content';

@Component({
  selector: 'wiki-empty-state',
  templateUrl: './wiki-empty-state.component.html',
  styleUrls: ['./wiki-empty-state.component.scss'],
})
export class WikiEmptyStateComponent implements OnInit {
  private readonly notionLink = Constants.LEARN_MORE_WIKIS_URL;
  readonly emptyStateIcon: Icon = {
    lightUrl: 'assets/empty-state/wiki/empty-wikis-light.svg',
    darkUrl: 'assets/empty-state/wiki/empty-wikis-dark.svg',
  };
  wikiContent = wikiContent;

  @Input() collection: Wiki.WikiCollection;
  @Input() canEdit: boolean;

  constructor(
    private eventsService: EventsService,
    private collectionsService: CollectionsService,
    private collectionsUtilService: CollectionsUtilService,
    private hubService: HubService
  ) {}

  ngOnInit(): void {
    this.eventsService.event('wikis.empty_state_pageview');
    this.hubService.preventSearch = true;
  }

  createNewWiki() {
    const state = this.collection ? 'new' : 'new-from';
    this.eventsService.event('wikis.empty_state_new_wiki');
    this.collectionsService.openNewCollection('Wiki', state);
  }

  openLearnMore() {
    this.collectionsUtilService.openLearnMore(this.notionLink);
  }
}
